<template>
    <v-app> <ListaNotifiche/> </v-app>
</template>

<script>
import ListaNotifiche from "@/components/NOTIFICHE/ListaNotifiche.vue"

export default {
  name: "Notifiche",
  components: { ListaNotifiche },
}

</script>
